import { validateEmail } from '@/lib/validator/validateEmail';
import { makeFormData } from '@/utils/makeFormData';
import { atom } from 'nanostores';

export class FooterStore {
  $email = atom('');

  $emailError = atom(false);

  $acceptPrivacy = atom(true);

  $acceptPrivacyError = atom(false);

  $acceptMailings = atom(true);

  $acceptMailingsError = atom(false);

  $isLoading = atom(false);

  store;

  constructor(store) {
    this.store = store;
  }

  setEmail(value) {
    this.$email.set(value.trim());
    this.resetErrors();
  }

  setAcceptPrivacy(value) {
    this.$acceptPrivacy.set(value);
    this.resetErrors();
  }

  setAcceptMailings(value) {
    this.$acceptMailings.set(value);
    this.resetErrors();
  }

  async subscribe() {
    const { api } = this.store.apiStore;

    if (!this.validateForm()) return;

    this.$isLoading.set(true);
    this.store.loadingStore.lock('subscribe');

    try {
      const email = this.$email.get();
      const formData = makeFormData({
        name: email,
        email,
        comment: `"${email}" subscribed to promotional mailings`,
        customer_type: 'personal',
      });
      await api.createOrderWithoutPlans(formData);
      this.resetForm();
      this.store.successPopupStore.open();
    } catch (e) {
      console.error(e);
    }

    this.store.loadingStore.unlock('subscribe');
    this.$isLoading.set(false);
  }

  validateForm() {
    this.$emailError.set(!validateEmail(this.$email.get()));
    this.$acceptPrivacyError.set(!this.$acceptPrivacy.get());
    this.$acceptMailingsError.set(!this.$acceptMailings.get());

    const isError = this.$emailError.get() || this.$acceptPrivacyError.get() || this.$acceptMailingsError.get();
    return !isError;
  }

  resetErrors() {
    this.$emailError.set(false);
    this.$acceptPrivacyError.set(false);
    this.$acceptMailingsError.set(false);
  }

  resetForm() {
    this.resetErrors();
    this.$email.set('');
    this.$acceptPrivacy.set(true);
    this.$acceptMailings.set(true);
  }
}
